export default __webpack_public_path__ + "static/media/pools.ebbbad37.png";